var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[(_vm.$route.name != 'Login')?_c('header-menu'):_vm._e(),(_vm.$route.name != 'Login')?_c('main-menu'):_vm._e()],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }